import clsx from 'clsx'
import Router from 'next/router'
import PropTypes from 'prop-types'
import React from 'react'
import Icon, { ICONS, ICON_SIZE } from 'components/common/icon'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import StateStorage from 'lib/state-storage'
import { hasLocizeTranslation } from 'lib/utils/locize'
import sustainableData from './const'
import styles from './styles.scss'

const getSustainableClassName = (className) =>
  `pdp__product-sustainable__${className}`

const getSustainabilityLink = () => {
  const shop = StateStorage.getShop()
  const lang = StateStorage.getLanguage()

  const href = '/lookbooks/sustainability'
  const as = `/${shop}/${lang}${href}`

  return { href, as }
}

const ProductSustainable = ({ onLinkClick, sustainableItem, t }) => {
  const onClick = () => {
    const { href, as } = getSustainabilityLink()
    onLinkClick(true, 'sustainableLink')
    Router.push(href, as)
  }

  return (
    <div className="pdp__product-sustainable">
      <style jsx>{styles}</style>
      {sustainableItem.map((name) => {
        const { icon: iconName, title, subTitle } = sustainableData[name] || {}

        if (!title) {
          return null
        }

        return (
          <div
            key={iconName}
            className={getSustainableClassName('item-container')}
          >
            <Icon
              alt={`${iconName} icon`}
              src={ICONS[iconName]}
              size={ICON_SIZE.medium}
            />
            <div className={getSustainableClassName('item')}>
              <div
                className={clsx(
                  getSustainableClassName('title'),
                  Typo.subtitle2,
                )}
              >
                {hasLocizeTranslation(t, title.key, title.text)}
              </div>
              <div
                className={clsx(
                  getSustainableClassName('subtitle'),
                  Typo.body2,
                )}
              >
                {hasLocizeTranslation(t, subTitle.key, subTitle.text)}
              </div>
            </div>
          </div>
        )
      })}
      <button
        className={clsx(getSustainableClassName('link'), Typo.overline)}
        style={{ marginLeft: `${ICON_SIZE.medium + 16}px` }}
        onClick={onClick}
      >
        {hasLocizeTranslation(
          t,
          'PDP_SUSTAINABLE_LINK',
          'What’s sustainability edit?',
        )}
      </button>
    </div>
  )
}

ProductSustainable.propTypes = {
  onLinkClick: PropTypes.func.isRequired,
  sustainableItem: PropTypes.arrayOf(PropTypes.string).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(ProductSustainable)
